import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AccountMcpConnectButton } from '@/Domain/components/Integration/AccountMcpConnect/AccountMcpConnectButton';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { CAL_LINK, useCalModal } from '@/Domain/hooks/useCalModal.hook';

export const OnboardingActionCards = () => {
  const { t } = useTranslation(['onboarding_progress', 'account_mcp']);
  const openCalModal = useCalModal();

  return (
    <div className="flex flex-col gap-2" data-testid="onboarding-action-cards">
      <AccountMcpConnectButton
        size="md"
        className="w-full border-indigo-100 bg-indigo-100 text-indigo-900 hover:bg-indigo-200 dark:border-indigo-800 dark:bg-indigo-900 dark:text-indigo-200 dark:hover:bg-indigo-800"
      >
        <span className="min-w-0 truncate">{t('account_mcp:manage_cta')}</span>
      </AccountMcpConnectButton>
      <Button
        variant="secondary"
        size="md"
        onClick={() => openCalModal(CAL_LINK.productDemo, 'ai_preview')}
        className="w-full"
        data-testid="book-demo-button"
      >
        <Calendar className="h-4 w-4" />
        <span className="min-w-0 truncate">{t('complete_actions.book_demo')}</span>
      </Button>
    </div>
  );
};
